// extracted by mini-css-extract-plugin
export default {"container":"ElementWithIcon_container__AiF-L","logoContainer":"ElementWithIcon_logoContainer__PjlsD"};